module.exports = __webpack_public_path__ + "img/268-3.6cf8bd5a.png";